<template>
  <div class="justify-content-center"></div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
<style>
body {
  background-color: var(--bg-body-color);
}
</style>
